const YOUTUBE_HOSTS = new Set(['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be']);

const isHttpsYoutubeUrl = (value) => {
  if (typeof value !== 'string') return null;

  const raw = value.trim();
  if (!raw || !/^https:\/\//i.test(raw)) return null;

  try {
    const parsed = new URL(raw);
    const hostname = parsed.hostname.toLowerCase();

    // The legacy route performs a full-page redirect. Keep that redirect
    // limited to YouTube and reject user-info/non-default-port tricks.
    if (
      parsed.protocol !== 'https:' ||
      !YOUTUBE_HOSTS.has(hostname) ||
      parsed.username ||
      parsed.password ||
      parsed.port
    ) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

/**
 * Return a canonical, safe YouTube URL for the old /media redirect.
 * Empty string means the configured value is not a permitted destination.
 */
export const sanitizeYoutubeUrl = (value) => isHttpsYoutubeUrl(value)?.href || '';

/**
 * Resolve the legacy media destination. The explicit landing CTA wins, but
 * an invalid CTA must not prevent a valid YouTube social link from working.
 */
export const getYoutubeRedirectUrl = (config) => {
  const ctaPath = sanitizeYoutubeUrl(config?.landing?.youtube?.ctaPath);
  if (ctaPath) return ctaPath;

  const socials = Array.isArray(config?.footer?.socials) ? config.footer.socials : [];
  const youtubeSocial = socials.find(
    (item) =>
      typeof item?.platform === 'string' &&
      item.platform.trim().toLowerCase() === 'youtube' &&
      sanitizeYoutubeUrl(item.url)
  );
  return sanitizeYoutubeUrl(youtubeSocial?.url);
};
